/*eslint-disable*/
import React, { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { MailOutlineRounded } from "@material-ui/icons";
import Phone from "@material-ui/icons/Phone";
import jslogo from "assets/img/logo-jsi.jpeg";
import Marquee from "react-fast-marquee";
import Grid from "@material-ui/core/Grid";
import brandTheme from "../../../brandTheme/Theme";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
const useStyles = makeStyles((theme) => ({
  mainContainer: {
    bottom: 0,
    backgroundColor: brandTheme.footerBackGroundColor,
    position: "absolute",
    width: "100%",
    padding: "5px 0px",
    height:'62px',
    display:'none',
       '@media only screen and (max-width: 600px)': {
        height:'auto',
      },
  },
  container: {
    alignItems: "center",
    width: "90%",
    display: "flex",
    margin: "0 auto",
    justifyContent: "space-between",
    '@media (max-width:600px)':{
      display:'block',

    },
  },
  content: {
    color: brandTheme.black,
    fontSize: "14px",
    fontWeight: 400,
   },
  logo: {
    width: "135px",
    height: "50px",
    '@media (max-width:600px)':{
      alignItems:'center',
    },
  },
  logoContainer:{
    '@media (max-width:600px)':{
      alignItems:'center',
      padding:"0 90px"
    },
  },
  contentContainer: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    marginLeft: "5px",
    fontFamily: brandTheme.font.poppins,
    color: brandTheme.black,
  },
  mainContent: {
    fontSize: "12px",
    fontWeight: 400,
  },
  icon: {
    width: "15px",
    marginLeft: "15px",
  },
}));

const Footer = ({featureFlagState}) => {
  const classes = useStyles();
  return (
    <Grid container className={classes.mainContainer}>
      <Grid item className={classes.container} xs={12} sm={12} md={12}>
        <Grid item className={classes.container} xs={12} sm={9} md={10}>
          <Marquee gradient={false} className={classes.marqueContainer}>
            <div className={classes.a} style={{ display: "flex" }}>
              <span className={classes.contentContainer}>
                <span className={classes.mainContent}>{featureFlagState?.footerHeader}</span>
                <span className={classes.content}>
                  {featureFlagState?.footerContent}
                </span>
              </span>
              <span className={classes.contentContainer}>
                <MailOutlineRounded className={classes.icon} />{" "}
                <span className={classes.content}>{featureFlagState?.footerEmail}</span>
              </span>
            </div>
          </Marquee>
        </Grid>
        <Grid item className={`${classes.container} ${classes.logoContainer}`} xs={12} sm={3} md={2}>
          <span className={classes.a}>
            <img src={jslogo} alt="JS LOGO" className={classes.logo} />
          </span>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default Footer;
